document.querySelectorAll('[data-quick-view]').forEach((trigger) => {
  trigger.addEventListener('click', () => {
    const dialog = document.getElementById('quick-view-dialog');
    const panel = dialog ? dialog.querySelector('dialog') : null;
    if (!panel) return;

    const image = document.getElementById('quick-view-image');
    const tag = document.getElementById('quick-view-tag');
    const title = document.getElementById('quick-view-dialog-title');
    const description = document.getElementById('quick-view-description');
    const price = document.getElementById('quick-view-price');
    const link = document.getElementById('quick-view-link');

    if (image) {
      image.src = trigger.dataset.image || '';
      image.alt = trigger.dataset.imageAlt || '';
      image.style.display = trigger.dataset.image ? '' : 'none';
    }
    if (tag) {
      tag.textContent = trigger.dataset.tag || '';
      tag.style.display = trigger.dataset.tag ? '' : 'none';
    }
    if (title) {
      title.textContent = trigger.dataset.title || '';
    }
    if (description) {
      description.textContent = trigger.dataset.description || '';
      description.style.display = trigger.dataset.description ? '' : 'none';
    }
    if (price) {
      price.textContent = trigger.dataset.price || '';
    }
    if (link) {
      link.href = trigger.dataset.url || '#';
    }

    panel.showModal();
  });
});

document.querySelectorAll('[data-quick-view-close]').forEach((button) => {
  button.addEventListener('click', () => {
    const panel = button.closest('dialog');
    if (panel) {
      panel.close();
    }
  });
});

document.getElementById('quick-view-dialog')?.addEventListener('click', (event) => {
  const panel = event.currentTarget.querySelector('dialog');
  if (event.target === panel) {
    panel.close();
  }
});
